export default "<app-persona-list></app-persona-list>\n"